import { useConfigStore } from '~/store/useConfigStore'
import type { Team } from '~/types'

export const useAdParams = (team?: MaybeRef<Team.Model>) => {
  const store = useConfigStore()
  const { googleAdManagerCode: leagueAdCode, googleAdManagerId: leagueAdId } = storeToRefs(store)
  const { adCode: teamAdCode, adId: teamAdId } = useTeam(team)

  const code = computed<Maybe<string>>(() => {
    if (unref(teamAdCode)) {
      return `teams/${unref(teamAdCode)}`
    }

    return unref(leagueAdCode)
  })

  const id = computed<Maybe<string>>(() => {
    if (unref(teamAdId)) {
      return unref(teamAdId)
    }

    return unref(leagueAdId)
  })

  return {
    code,
    id,
  }
}
